import { Text, Card, Flex, Tooltip } from "@radix-ui/themes";

export function MetricCard({ metricName, metric, updates, hideTooltip = false }) {

  const getColor = (text) => {
    if (text === '+0%') {
      return 'inherit'; // No color change for +0%
    }
    return text.includes('-') ? 'var(--red-9)' : 'var(--grass-9)';
  };

  const getStyledUpdates = (updates) => {
    const match = updates.match(/([+-]?\d+%)/);
    if (match) {
      const [number] = match;
      const rest = updates.replace(number, '');
      return (
        <>
          <span style={{ color: getColor(number) }}>{number}</span>
          {rest}
        </>
      );
    }
    return updates;
  };

  return (
    <Card style={{  display: "flex", padding: 'var(--space-4)', flexDirection: 'column', justifyContent: 'space-between',
      alignItems: 'flex-start', flex: '1 0 0', alignSelf: 'stretch', height: '100%' }}>
      <Flex direction="column" gap="2" width="100%">
        <Flex direction="column"  align="start"  gap="5" style={{alignSelf: "stretch"}}>
          <Text gap="2" size="2" weight="medium" color="gray">{metricName}</Text>
          <Text size="6" weight="bold">{metric}</Text>
        </Flex>
        <Flex justify="between"  align="center" style={{ alignSelf: "stretch" }}>
          {hideTooltip ? (
            <Text size="1" weight="regular" color="gray">{getStyledUpdates(updates)}</Text>
          ) : (
            <Tooltip content="Last period refers to the previous equivalent time range.">
              <Text size="1" weight="regular" color="gray">{getStyledUpdates(updates)}</Text>
            </Tooltip>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}
